import React from 'react';
import PropTypes from 'prop-types';

import { AnimatePresence } from 'framer-motion';
import Header from '../Site/header';
import Footer from '../Site/Footer';
import {
  BodyWrapper,
  MainContent,
  AnimationVariants,
} from '../Site/styles/LayoutStyled';

const LoyaltyLayout = ({ location, children }) => {
  return (
    <>
      <Header />
      <BodyWrapper>
        <AnimatePresence>
          <MainContent
            key={location.pathname}
            variants={AnimationVariants}
            initial="initial"
            animate="enter"
            exit="exit"
          >
            {children}
          </MainContent>
        </AnimatePresence>
      </BodyWrapper>
      <Footer />
    </>
  );
};

LoyaltyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default LoyaltyLayout;
